import request from "@/utils/request";

export function bannerAreaList(params) {
  return request.get('/web/banner', params, { login: false });
}

export function artCourseList(params) {
  return request.get('/course/list', params, { login: false });
}
export function courseList(params) {
  return request.get('/course/webList', params, { login: false });
}
// 获取课程视频详情
export function artCourseDetail(id, params) {
  return request.get(`/course/detail/${id}`, params, { login: false });
}

// 收藏（添加收藏、取消收藏共用一个接口）
export function collectAdd(params) {
  return request.post('/relation/collect/add', params, { login: true });
}
/*
 * 课程使用须知
*/
export function getInstructions() {
  return request.get(`/course/instructions`, {},{ login: false });
}
/*
 * 课程评论列表
*/
export function getReplyList (data){
  return request.post('/course/reply/list',data, { login: false });
}
// 取消收藏批量取消收藏{ids:[1,2,3]}
export function collectDel(params) {
  return request.post('/relation/collect/del', params, { login: true });
}

// 获取点播视频
export function getPlayAuth(id) {
  return request.get(`/course/getPlayAuth/${id}`, {},{ login: true });
}

// 视频答题
export function chapterRandom(params) {
  return request.get(`/artQuestionBank/chapter/random`, params, { login: true });
}

// 课程评论查询
export function artCourseComment(params) {
  return request.get(`/comment/artCourseComment`, params, { login: true });
}

// 新增课程评论
export function artCourseCommentPost(params) {
  return request.post(`/comment/artCourseComment`, params, { login: true });
}

// 点赞
export function artCourseCommentLike(params) {
  return request.post(`/comment/artCourseCommentLike`, params, { login: true });
}

// 答题
export function artQuestionBankAnswer(params) {
  return request.post(`/artQuestionBank/answer`, params, { login: true });
}

// 推荐列表
export function expertTank(id) {
  return request.get(`/course/expertTank/${id}`,{}, { login: true });
}

// 获取表情列表
export function artExpression(params) {
  return request.get(`/artExpression/list`, params, { login: true });
}

/*
 *订单确认
*/
export function getOrderConfirm (params){
  return request.post('/courseOrder/confirm', params, { login: true });
}
/*
 *计算订单优惠及服务费
*/
export function getOrderComputed  (key){
  return request.post('/courseOrder/computed/'+key,{}, { login: true });
}

/*
 *订单创建
*/
export function getOrderCreate(key,data){
  return request.post('/courseOrder/create/'+key,data, { login: true });
}
/*
 * 订单详情接口
*/
export function getOrderDetail(key){
  return request.get('/courseOrder/detail/'+key,{}, { login: true });
}
/*
 * 课程订单支付
*/
export function payCourse(data){
  return request.post('/courseOrder/pay', data, { login: true });
}
/*
 * 取消订单
*/
export function setCancelOrder(data){
  return request.post('/courseOrder/order/cancel', data, { login: true });
}
